import { memo, useMemo } from "react";
import { NodeProps } from "reactflow";

import styles from "./index.less";

import { FlowModuleItemType } from "@packages/flow-core/module";

import NodeCard from "../NodeCard";
import { useFlow } from "../FlowEdit/useFlow";
import Divider from "../Divider";
import RenderInput from "../render/RenderInput";
import RenderOutput from "../render/RenderOutput";
import RenderToolInput from "../render/RenderToolInput";

/**
 * 新的判断器 NodeCasesSwitcher
 */
export default memo(function ({
  data,
  selected,
}: NodeProps<FlowModuleItemType>) {
  const { moduleId, inputs, outputs } = data;

  const { splitToolInputs } = useFlow();
  const { toolInputs, commonInputs } = splitToolInputs(inputs, moduleId);

  const visibleInputs = useMemo(
    () => commonInputs.filter((item) => item.type !== "hidden"),
    [inputs]
  );

  return (
    <NodeCard minWidth={580} selected={selected} {...data}>
      {toolInputs.length > 0 && (
        <>
          <Divider text="工具输入" />
          <div className={styles.content}>
            <RenderToolInput moduleId={moduleId} inputs={toolInputs || []} />
          </div>
        </>
      )}
      {visibleInputs?.length > 0 && (
        <>
          <Divider text="输入" />
          <div className={styles.content}>
            <RenderInput flowInputList={visibleInputs} moduleId={moduleId} />
          </div>
        </>
      )}
      {outputs?.length > 0 && (
        <>
          <Divider text="输出" />
          <div className={styles.content}>
            <RenderOutput flowOutputList={outputs} moduleId={moduleId} />
          </div>
        </>
      )}
    </NodeCard>
  );
});
